var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M25.84 24.05 40.92 8.97a1.3 1.3 0 0 0 0-1.84 1.3 1.3 0 0 0-1.84 0L24 22.2 8.92 7.13a1.3 1.3 0 0 0-1.84 0 1.3 1.3 0 0 0 0 1.84l15.08 15.08L7.08 39.13A1.3 1.3 0 0 0 8 41.35c.33 0 .67-.13.92-.38L24 25.89l15.04 15.04a1.31 1.31 0 0 0 1.84 0 1.3 1.3 0 0 0 0-1.84z",
  clipRule: "evenodd"
})));
export { SvgCross as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/cross.svg", import.meta.url).toString();